import Vue from 'vue'

/**防抖指令 防止一个事件频繁触发回调函数 **/
const debounce =  Vue.directive('debounce', {
    bind: function(el, binding, vnode) {
        let timer ;
        let delay = binding .args ;
        if(!delay) delay = 1000;
        el.addEventListener('click', () => {
            if (timer) {
                clearTimeout(timer)
                return ; //+
            }
            timer = setTimeout(() => {
                binding.value() ;
            }, delay) //+
        })
    },
})
    
    /**节流指令 在一定时间内只调用一次函数 **/
    const throttle = Vue.directive('throttle',{
        inserted: function(el, binding, vnode){
            let delay = binding.args ;
            if(!delay) delay = 1000 ;
            let timer = null ;
            el.addEventListener('click',() => {
                if(timer) {
                   return ; 
                }else{
                    binding.value();
                    timer = null ;
                }
            })
        }
    })

export  {debounce,throttle}